<template>
    <div v-if="successMessage" class="success-message">
        {{ successMessage }}
    </div>
</template>

<script setup lang="ts">
defineProps<{ 
	successMessage: string;
}>()
</script>